import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/sys/tenant/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/sys/tenant/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/sys/tenant/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/sys/tenant/submit',
    method: 'post',
    data: row
  })
}

export const isValidServerName = (serveName, id) => {
  return request({
    url: '/sys/tenant/isValid',
    method: 'get',
    params: {
      serveName,
      id
    }
  })
}
